import { ReactComponent as CogIcon } from 'assets/icons/icon-cog.svg';
import Link from 'next/link';
import React, { FC } from 'react';
import APP_ROUTES from 'utils/routes';
import { AccountBarStyled, Button } from './account-bar.styles';

interface Props {
  name?: string | null;
}

const AccountBar: FC<Props> = ({ name }) => {
  const greeting = `Welcome${name ? `, ${name}` : ''}`;

  return (
    <AccountBarStyled>
      {greeting}{' '}
      <Link href={APP_ROUTES.users.settings} passHref>
        <Button aria-label='Settings'>
          <CogIcon aria-hidden />
        </Button>
      </Link>
    </AccountBarStyled>
  );
};

export default AccountBar;
